import LocalStorage from "../LocalStorage";
import {isDefined} from "../../../utils/Utils";
import moment = require("moment");

/**
 * Day view filters (selected date)
 */
export class DayViewFilters {
	constructor(public date: moment.Moment,
		public mapState: number,
		public displayHomes: boolean,
		public displayLocations: boolean,
		public displayAppointments: boolean,
		public filterSEWithAppointments: boolean) {}

	static default(): DayViewFilters {
		return new DayViewFilters(moment(), 0, true, true, true, false);
	}

	/**
	 * Parse local storage data.
	 * @param data data to parse.
	 * @returns {DayViewFilters}
	 */
	static getFromLocalStorageData(data: any): DayViewFilters {
		const defaultFilter = DayViewFilters.default();
		if (!isDefined(data)) {
			return defaultFilter;
		}
		const date = isDefined(data.date) ? data.date : defaultFilter.date;
		const mapState = isDefined(data.mapState) ? data.mapState : defaultFilter.mapState;
		const displayHomes = isDefined(data.displayHomes) ? data.displayHomes : defaultFilter.displayHomes;
		const displayLocations = isDefined(data.displayLocations) ? data.displayLocations : defaultFilter.displayLocations;
		const displayAppointments = isDefined(data.displayAppointments) ? data.displayAppointments :
			defaultFilter.displayAppointments;
		const seWithAppsOnly = isDefined(data.filterSEWithAppointments) ? data.filterSEWithAppointments :
			defaultFilter.filterSEWithAppointments;
		return new DayViewFilters(date, mapState, displayHomes, displayLocations, displayAppointments, seWithAppsOnly);
	}

	updateDate(value: moment.Moment): DayViewFilters {
		this.date = value;
		LocalStorage.saveDayViewFilters(this);
		return this;
	}

	updateMapState(value: number): DayViewFilters {
		this.mapState = value;
		LocalStorage.saveDayViewFilters(this);
		return this;
	}

	updateHomes(value: boolean): DayViewFilters {
		this.displayHomes = value;
		LocalStorage.saveDayViewFilters(this);
		return this;
	}

	updateLocations(value: boolean): DayViewFilters {
		this.displayLocations = value;
		LocalStorage.saveDayViewFilters(this);
		return this;
	}

	updateAppointments(value: boolean): DayViewFilters {
		this.displayAppointments = value;
		LocalStorage.saveDayViewFilters(this);
		return this;
	}

	updateSEFilter(value: boolean): DayViewFilters {
		this.filterSEWithAppointments = value;
		LocalStorage.saveDayViewFilters(this);
		return this;
	}
}
